export default __webpack_public_path__ + "static/default-bottom-broker-image-9e29f733cca8f04a1478e349465bc83f.jpg";